<template>
  <!-- heading starts -->
  <div>
    <div>
      <v-sheet class="rounded-0 shadow-none">
        <v-row class="saved-lineup mx-2" justify="center">
          <v-col cols="12" md="12" sm="12" class="mt-2 pb-0">
            <!-- Selector starts -->
            <v-row class="d-none d-md-flex">
              <v-col cols="4" md="1" sm="4" class="body-2 text-end mt-1">
                <strong>Slate Time:</strong>
              </v-col>
              <v-col cols="7" md="2" sm="7" class="ml-n4 mt-n1">
                <v-select
                  light
                  :items="Slates"
                  item-text="OperatorName"
                  item-value="SlateID"
                  v-model="slateId"
                  outlined
                  dense
                  @change="fetchPlayerTrends()"
                  style="z-index: 9"
                >
                  <template v-slot:item="{ item }">
                    <small class="caption">
                      {{ item.OperatorName }}&nbsp;
                      {{ item.OperatorStartTime | timeFormat }}
                      ({{ item.NumberOfGames }}games)
                    </small>
                  </template>
                </v-select>
              </v-col>
              <!-- Selector ends -->

              <!-- Radio buttons -->
              <v-col
                cols="12"
                md="3"
                sm="12"
                class="ml-5 mt-n8"
                align-self="center"
              >
                <v-radio-group v-model="radio" row>
                  <v-radio
                    label="Classic"
                    value="classic"
                    @change="onlyClassic()"
                  ></v-radio>
                  <v-radio
                    label="Single Game"
                    value="others"
                    @change="otherThanClassic()"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <!-- Radio buttons ends -->
            </v-row>

            <!-- only for mobile view -->
            <v-row class="d-block d-md-none mt-0">
              <v-col cols="5" md="4" sm="5" class="cus-radio-bnt float-left">
                <!-- Radio buttons -->
                <v-radio-group v-model="radio" row>
                  <v-radio
                    label="Classic"
                    value="classic"
                    @change="onlyClassic()"
                  ></v-radio>
                  <v-radio
                    label="Single Game"
                    value="others"
                    @change="otherThanClassic()"
                  ></v-radio>
                </v-radio-group>
                <!-- Radio buttons ends -->
              </v-col>
              <!-- Selector start -->
              <v-col
                cols="7"
                md="4"
                sm="5"
                class="body-2 float-right cus-caption-6 pt-0"
              >
                <strong>Slate Time:</strong>
                <v-select
                  light
                  :items="Slates"
                  item-text="OperatorName"
                  item-value="SlateID"
                  v-model="slateId"
                  solo
                  dense
                  @change="fetchPlayerTrends()"
                >
                  <template v-slot:item="{ item }">
                    <small class="caption">
                      {{ item.OperatorName }}&nbsp;
                      {{ item.OperatorStartTime | timeFormat }}
                      ({{ item.NumberOfGames }}games)
                    </small>
                  </template>
                </v-select>
              </v-col>
              <!-- Selector ends -->
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>

      <div v-if="getTeamLoader" class="mb-3 mt-5">
        <v-skeleton-loader
          :loading="getTeamLoader"
          type="card-heading,table,paragraph"
          elevation="2"
        >
        </v-skeleton-loader>
      </div>

      <!--//* Player trends table -->
      <div v-else>
        <v-sheet elevation="3" class="mt-6 mb-2 player-trends-table">
          <div>
            <v-data-table
              dense
              :headers="headers"
              :items="playerTrend"
              :item-key="playerTrends._id"
              :items-per-page="playerTrends.length"
              class="elevation-1 player-trend-ins mx-3 mx-md-0"
              :footerProps="footerProps"
              mobile-breakpoint="0"
              :sort-by="['DraftKingsProjection', 'FandDualProjection']"
              sort-desc
            >
              <!-- header -->
              <template
                v-for="h in headers"
                v-slot:[`header.${h.value}`]="{ headers }"
              >
                <v-tooltip bottom :key="h.text">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ h.text }}</span>
                  </template>
                  <span>{{ h.hint }}</span>
                </v-tooltip>
              </template>
              <!-- header -->

              <!-- profile image -->
              <template v-slot:item.PhotoUrl="{ item }">
                <v-avatar width="37" height="48">
                  <img :src="item.PhotoUrl" />
                </v-avatar>

                <!-- last 3 fppg -->
                <v-col class="ml-md-n4 ml-sm-0" cols="12" md="12" sm="12">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-if="
                          Slates.length !== 0 &&
                          Slates[0].Operator == 'DraftKings'
                        "
                        class="body-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ item.lastfivedraftkingspoint[0] }},
                        {{ item.lastfivedraftkingspoint[1] }},
                        {{ item.lastfivedraftkingspoint[2] }}
                      </span>

                      <span
                        v-if="
                          Slates.length !== 0 && Slates[0].Operator == 'FanDuel'
                        "
                        class="body-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ item.lastfivefandualpoint[0] }},
                        {{ item.lastfivefandualpoint[1] }},
                        {{ item.lastfivefandualpoint[2] }}
                      </span>
                    </template>
                    <span>Last 3 games</span>
                  </v-tooltip>
                </v-col>
                <!-- last 3 fppg ends-->
              </template>

              <!-- profile image ends -->

              <!-- s.no -->
              <template v-slot:item._id="{ index }">
                <p class="body-2">{{ index + 1 }}</p>
              </template>
              <!-- s.no -->

              <!-- position -->
              <template v-slot:item.DraftKingsPosition="{ item }">
                <p
                  v-if="
                    Slates.length !== 0 && Slates[0].Operator == 'DraftKings'
                  "
                  class="body-2"
                >
                  {{ item.DraftKingsPosition }}
                </p>

                <p
                  v-if="Slates.length !== 0 && Slates[0].Operator == 'FanDuel'"
                  class="body-2"
                >
                  {{ item.FanDuelPosition }}
                </p>
              </template>
              <!-- position -->

              <!-- performance -->
              <template v-slot:item.status="{ item }">
                <v-avatar v-if="item.status == 'Hot'" width="30" height="30">
                  <img src="/hot.png" />
                </v-avatar>
                <v-avatar v-if="item.status == 'Cold'" width="30" height="30">
                  <img src="/snowflakes.png" />
                </v-avatar>
              </template>
              <!-- performance -->

              <!-- player name -->
              <template v-slot:item.Name="{ item }">
                <router-link
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  {{ item.Name }}
                </router-link>
              </template>
              <!-- player name ends -->

              <!--//* matchup -->
              <template v-slot:item.Team="{ item }">
                <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
                  {{ item.Opponent }}&nbsp;
                  <small class="black--text">@</small>
                  <span>
                    {{ item.Team }}
                  </span>
                </p>

                <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
                  {{ item.Team }}&nbsp;
                  <small class="black--text">@</small>
                  <span>
                    {{ item.Opponent }}
                  </span>
                </p>
              </template>
              <!--//* matchup ends -->

              <template v-slot:item.HomeOrAway="{ item }">
                <!-- Blue dot - 'active',
              green dot - 'positive',
              yellow dot -'intermediary'
              red dot - 'negative' -->
                <v-row class="ml-0">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-show="item.InjuryStatus == null"
                        v-on="on"
                        v-bind="attrs"
                      >
                        <status-indicator status="positive" pulse />
                      </v-col>
                    </template>
                    <span>Healthy</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-show="item.InjuryStatus == 'Out'"
                        v-on="on"
                        v-bind="attrs"
                      >
                        <status-indicator status="negative" pulse />
                      </v-col>
                    </template>
                    <span>Out</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-on="on"
                        v-bind="attrs"
                        v-show="item.InjuryStatus == 'Questionable'"
                      >
                        <status-indicator status="intermediary" pulse />
                      </v-col>
                    </template>
                    <span>Questionable</span>
                  </v-tooltip>

                  <!-- <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-on="on"
                        v-bind="attrs"
                        v-show="item.HomeOrAway == 'HOME'"
                      >
                        <status-indicator status="positive" pulse />
                      </v-col>
                    </template>
                    <span>HOME</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-on="on"
                        v-show="item.HomeOrAway == 'AWAY'"
                      >
                        <status-indicator status="negative" pulse />
                      </v-col>
                    </template>
                    <span>AWAY</span>
                  </v-tooltip> -->
                </v-row>
              </template>

              <!--Avg FPPG -->
              <template v-slot:item.FPPG="{ item }">
                <p
                  v-if="
                    Slates.length !== 0 && Slates[0].Operator == 'DraftKings'
                  "
                  class="body-2"
                >
                  {{ item.lastfivedraftFPPG }}
                </p>
                <p
                  v-if="Slates.length !== 0 && Slates[0].Operator == 'FanDuel'"
                  class="body-2"
                >
                  {{ item.lastfivefandualFPPG }}
                </p>
              </template>
              <!--Avg FPPG -->

              <!-- salary -->
              <template v-slot:item.DraftKingsSalary="{ item }">
                <p
                  v-if="
                    Slates.length !== 0 && Slates[0].Operator == 'DraftKings'
                  "
                  class="body-2 green--text"
                >
                  {{ item.DraftKingsSalary }}
                </p>
                <p v-else class="body-2 green--text">
                  {{ item.FanDuelSalary }}
                </p>
              </template>
              <!-- salary ends -->

              <!-- FPPG -->
              <template v-slot:item.FPPG="{ item }">
                <p v-if="Slates[0].Operator == 'DraftKings'" class="body-2">
                  {{ item.FPPG >> 0 }}
                </p>
                <p v-else class="body-2">{{ item.FPPGfanduel >> 0 }}</p>
              </template>
              <!-- FPPG -->

              <!-- projection -->
              <template v-slot:item.DraftKingsProjection="{ item }">
                <p
                  v-if="
                    Slates.length !== 0 && Slates[0].Operator == 'DraftKings'
                  "
                  class="body-2"
                >
                  {{ item.DraftKingsProjection >> 0 }}
                </p>
                <p v-else class="body-2">
                  {{ item.FandDualProjection >> 0 }}
                </p>
              </template>
              <!-- projection ends -->

              <!-- add line up -->
              <template v-slot:item._id="{ item }">
                <v-row class="mt-n3 ml-3">
                  <template v-if="item.type == 'lock'">
                    <!-- lock player button-->
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          x-small
                          fab
                          dark
                          :id="'LockButton_' + item._id"
                          color="green darken-3"
                          @click="unlockExposure($event, item)"
                        >
                          <v-icon>mdi-shield-lock-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Lock</span>
                    </v-tooltip>
                    <!-- exclude player button -->
                  </template>

                  <template v-else>
                    <!-- lock player button-->
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          x-small
                          fab
                          dark
                          :id="'LockButton_' + item._id"
                          color="blue"
                          @click="lockExposure($event, item)"
                        >
                          <v-icon>mdi-shield-lock-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Lock</span>
                    </v-tooltip>
                  </template>
                </v-row>
              </template>
              <!-- add line up ends-->
            </v-data-table>
          </div>
        </v-sheet>
      </div>
    </div>

    <!-- update Modal -->
    <upgrade-modal-2
      v-if="UpgradeModal"
      :UpgradeModal="UpgradeModal"
      @closeModal="goBack"
    />
    <!-- update Modal ends..-->
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { showPlayers } from "@/mixins/showPlayers.js";
import UpgradeModal2 from "@/components/Modal/UpgradeModal2.vue";

export default {
  name: "NflPlayerTrends",
  props: ["allSlate", "defaultSport", "defaultOptimizer"],
  mixins: [showPlayers],
  components: { UpgradeModal2 },

  data() {
    return {
      footerProps: { "items-per-page-options": [15, 30, 50, -1] },
      radio: "others",
      depth: [1, 2, 3, 4],
      Slates: [],
      slateId: "",
      operator: "",
      operatorGameType: "",
      userId: localStorage.getItem("user"),
      headers: [
        {
          text: "Profile",
          value: "PhotoUrl",
          hint: "profile",
        },
        { text: "", value: "_id", hint: "lock" },
        {
          text: "Position",
          value: "DraftKingsPosition",
          hint: "position",
          sortable: false,
        },
        {
          text: "Performance",
          value: "status",
          hint: "overall Performance",
        },
        { text: "Player", value: "Name", hint: "name" },
        { text: "Game", value: "Team", hint: "game" },
        { text: "Status", value: "HomeOrAway", hint: "status" },
        // { text: 'AVG FPPG', value: 'lastfivedraftFPPG' },
        { text: "Salary($)", value: "DraftKingsSalary", hint: "salary" },
        { text: "FPPG", value: "FPPG", hint: "Fantasy point per game" },
        { text: "Proj", value: "DraftKingsProjection", hint: "projection" },
        // { text: "Last 3 Game (FPPg)", value: "last3avg" },
      ],
    };
  },

  beforeMount() {
    if (this.userState) {
      if (this.userState.plantype == "Free") {
        this.UpgradeModal = true;
      } else {
        this.UpgradeModal = false;
      }
    }
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    // ? lock player...
    async lockExposure(event, player) {
      let payload = {
        user: this.userId,
        min: 100,
        max: 100,
        slatId: this.slateId,
        playerId: player.PlayerID,
        teamId: player.TeamID,
        type: player.type == "lock" ? "" : "lock",
        slatePlayerID: player.SlatePlayerID,
        playerrandomid: player.playerrandomid ? player.playerrandomid : "01234",
      };
      await this.$store.dispatch("NbaModule/SetExposure", payload).then(() => {
        //? update player info locally...
        this.updatePlayerInfo(payload);
      });
    },

    // * unlock player...
    async unlockExposure(event, player) {
      let payload = {
        playerId: player.PlayerID,
        user: this.userId,
        slatId: this.slateId,
        playerrandomid: player.playerrandomid ? player.playerrandomid : "01234",
      };
      await this.$store
        .dispatch("NbaModule/unlockPlayers", payload)
        .then(async () => {
          this.updatePlayerInfo(payload);
        });
    },

    updatePlayerInfo(player) {
      // player index
      if (
        this.Slates[0]?.Operator == "DraftKings" &&
        this.$parent.radio == "others"
      ) {
        let index = this.playerTrends.findIndex(
          (_player) => _player.playerrandomid === player.playerrandomid
        );
        if (index !== -1) {
          //check if player found in list
          let player_Info = this.playerTrends[index];
          Object.assign(player_Info, {
            min: player.min,
            max: player.max,
            type: player.type,
          });
          // update the player
          this.playerTrends.splice(index, 1, player_Info);
        }
      } else {
        //console.log('check is working for classic');
        let index = this.playerTrends.findIndex(
          (_player) => _player.PlayerID === player.playerId
        );
        // check if player found in list
        if (index !== -1) {
          let player_info = this.playerTrends[index];
          Object.assign(player_info, {
            min: player.min,
            max: player.max,
            type: player.type,
          });
          // update the player
          this.playerTrends.splice(index, 1, player_info);
        }
      }
    },
  },

  computed: {
    ...mapGetters("NflModule", ["getTeamLoader"]),
    ...mapState("NflModule", ["playerTrends"]),
    ...mapState("userModule", ["userState"]),

    playerTrend() {
      if (this.playerTrends.length > 0) {
        let playerArr = this.playerTrends.filter((item) => {
          return item.status !== "Neutral";
        });
        return playerArr;
      } else return;
    },
  },
};
</script>

<style lang="scss" scoped></style>
